import React, { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import { handleRedirectInternal } from '@/product/common/components'
import { useFormik } from 'formik'
import AlertContext from '@/product/context/alert/alertContext'
import SettingContext from '@/product/context/setting/settingContext'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import CampaignContext from '@/product/context/campaign/campaignContext'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import CustomDialog from '@/product/components/organisms/Dialog'
import CampaignManage from './CampaignManage'

const CampaignCreation = () => {
    const [isLoading, setIsLoading] = useState(true)
    const campaignContext = useContext(CampaignContext)
    const alertContext = useContext(AlertContext)
    const settingContext = useContext(SettingContext)
    const history = useHistory()
    const { setAlert } = alertContext
    const {
        configurations,
        getAllConfigurations,
        responseStatus: responseStatusCommuncation,
    } = settingContext
    const {
        getAllCampaigns,
        campaignAction,
        changeCampaignStatus,
        all_campaigns,
        responseStatus: responseStatusCampaign,
        clearResponse: clearResponseCampaign,
    } = campaignContext

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })
    const [isPopup, setPopup] = useState({
        popup: false,
        id: 0,
        secondaryID: 0,
    })
    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const togglePopup = (popup, id, secondaryID) => {
        if (popup) {
            setPopup({ popup, id, secondaryID })
        } else {
            setPopup({ popup, id: 0, secondaryID: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])
    const formik = useFormik({
        initialValues: {
            searchterm: '',
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            filters: {
                active: {
                    value: 1,
                    type: 'in',
                    field: 'cpn.is_active',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllCampaigns(values, 'allCampaigns')
        },
    })

    const formikCampaign = useFormik({
        initialValues: {
            campaign_template_id: 0,
            send: 0,
        },
        onSubmit: (values) => {
            setIsLoading(true)
            campaignAction(values, 'sendCampaign')
        },
    })

    const sendCampaign = (data) => {
        console.log(data, 'dddd')
        campaignAction(
            {
                id: data.id,
                campaign_template_id: data.secondaryID,
                send: 1,
            },
            'sendCampaign'
        )
        togglePopup(false)
    }

    useEffect(() => {
        if (all_campaigns && all_campaigns.from === 'allCampaigns') {
            console.log('alll', all_campaigns)
            setTableBody(
                all_campaigns.records.length ? all_campaigns.records : []
            )
            setIsLoading(false)
        }
    }, [all_campaigns])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.page = 1
        formik.values.searchterm = ''
        getAllCampaigns(formik.values, 'allCampaigns')
        /*  return () => {
            setTableBody([])
        }*/
    }, [])

    useEffect(() => {
        if (responseStatusCampaign) {
            if (
                (responseStatusCampaign.from === 'GET_CAMPAIGNS' ||
                    responseStatusCampaign.from === 'sendCampaign' ||
                    responseStatusCampaign.from === 'statusChange') &&
                responseStatusCampaign.status === 'success'
            ) {
                toggleFullScreenPopup(false)
                setTableBody([])
                formik.values.page = 1
                formik.values.searchterm = ''
                getAllCampaigns(formik.values, 'allCampaigns')
            }
        }
    }, [responseStatusCampaign])

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            is_active: 0,
            id: 0,
            send: 0,
            status: '',
            table: 'campaigns',
        },
        onSubmit: (values) => {
            const dataValue = values
            if (
                dataValue.action === 'active' ||
                dataValue.action === 'deactivate' ||
                dataValue.action === 'delete' ||
                dataValue.action === 'trigger' ||
                dataValue.action === 'draft'
            ) {
                if (dataValue.action === 'active') {
                    dataValue.is_active = 1
                    dataValue.send = 1
                    dataValue.status = 'active'
                } else if (dataValue.action === 'deactivate') {
                    dataValue.is_active = 0
                } else if (dataValue.action === 'delete') {
                    dataValue.is_active = 2
                } else if (dataValue.action === 'draft') {
                    dataValue.is_active = 1
                    dataValue.send = 0
                    dataValue.status = 'draft'
                } else if (dataValue.action === 'trigger') {
                    dataValue.is_active = 1
                    dataValue.send = 1
                    dataValue.status = 'active'
                }
                console.log(values, 'vvv')
                changeCampaignStatus(values, 'statusChange')
                changeChangeStatus()
            }
        },
    })

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.id = data
        if (action === 'draft' || action === 'delete' || action === 'active') {
            setChangeStatus(true)
        }
    }

    const getMultipleAction = () => {
        let actionPush = []
        ;(actionPush.push({
            buttonType: 'edit',
            clickType: 'edit',
            onclick: onClickEdit,
            tooltipTitle: 'Edit',
        }),
            actionPush.push({
                buttonType: 'send',
                clickType: 'send',
                onclick: onClickEdit,
                tooltipTitle: 'Send Campaign',
            }))

        return actionPush
    }

    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'send') {
            togglePopup(true, id, secondaryID)
        } else {
            toggleFullScreenPopup(true, 'edit', id)
        }
    }

    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'ID',
            filterable: true,
            filterField: 'cpn.id',
        },
        {
            field: 'campaign_name',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Campaign Name',
            filterable: true,
            filterField: 'cpn.campaign_name',
        },
        {
            field: 'campaign_to',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'To',
            filterable: true,
            filterField: 'cpn.campaign_to',
        },
        {
            field: 'from_name',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'From Name',
            filterable: true,
            filterField: 'cpn.from_name',
        },
        {
            field: 'from_email',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'From Email',
            filterable: true,
            filterField: 'cpn.from_email',
        },
        {
            field: 'subject',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Subject Line',
        },
        {
            field: 'subject_preview',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Subject Preview',
        },
        {
            field: 'status',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Status',
        },
        {
            name: 'action',
            field: 'action',
            type: 'button',
            isMultiple: true,
            clickID: 'id',
            secondaryClickID: 'campaign_template_id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
            tableShow: 1,
        },
    ]
    const tableActions = [
        {
            label: 'Move to Active',
            icon: <span className="material-icons">publish</span>,
            onclick: onSelectMultiProducts,
            type: 'active',
        },
        {
            label: 'Move to Draft',
            icon: <span className="material-icons">bookmark_border</span>,
            onclick: onSelectMultiProducts,
            type: 'draft',
        },
        {
            label: 'Move to Deleted',
            icon: <span className="material-icons">cancel</span>,
            onclick: onSelectMultiProducts,
            type: 'delete',
        },
    ]

    const searchInfo = [
        // {
        //     label: 'Settings',
        //     placeholder: 'Enter Settings Title',
        //     class: 'col-md-4 col-sm-6 col-12',
        //     type: 'text',
        //     name: 'searchterm',
        //     formik: formik,
        // },
    ]

    return (
        <Layout>
            <div className="dashboard staticPages">
                {/* <CustomSearch searchInfo={searchInfo} formik={formik} /> */}
                <div className="d-flex justify-content-between align-items-center mt-4">
                    <Button
                        id="configView_variable_new"
                        variant="outlined"
                        className="btnOutlined"
                        onClick={() => toggleFullScreenPopup(true, 'new', 0)}
                    >
                        <span className="material-icons">note_add</span>Create
                        New Campaign
                    </Button>
                </div>
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={all_campaigns}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getAllCampaigns}
                    fromVariable={'allCampaigns'}
                />
            </div>
            <CampaignManage data={manage} function={toggleFullScreenPopup} />

            <CustomDialog
                className="adSlotPopup"
                title="Send Campaign"
                open={isPopup.popup}
                openFunction={() => togglePopup(false)}
            >
                <h5>
                    {'Please confirm if you want to continue with this action'}
                </h5>
                <div className="d-flex align-items-center justify-content-end mt-4">
                    <SecondaryButton
                        label="Cancel"
                        onClick={() => {
                            togglePopup(false)
                            formik.handleReset()
                        }}
                    />
                    <PrimaryButton
                        btnSize="ml-2"
                        label="Send"
                        onClick={() => sendCampaign(isPopup)}
                    />
                </div>
            </CustomDialog>
            <CustomDialog
                title={'Change status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>Are you sure you want to change the status</h5>
                <div className="actionWrapper">
                    <Button onClick={() => changeChangeStatus()}>Cancel</Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton type="submit" label="Confirm" />
                    </form>
                </div>
            </CustomDialog>
        </Layout>
    )
}
export default CampaignCreation
